import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'nameWithDashes',
})
export class NameWithDashesPipe implements PipeTransform {
    transform(name: string) {
        return !name ? '' : name.replace(/\s+/g, '-').replace(/[;/?:@&=+$,.!~*'()"]/g, '');
    }
}
